import { Component } from '@theme/component';

/** @typedef {typeof globalThis} Window */

/**
 * A component that handles title truncation with responsive behavior
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} [text] - The text element to truncate (optional)
 *
 * @extends {Component<Refs>}
 */
class ProductTitle extends Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.#initializeTruncation();
  }

  /**
   * Initialize the title truncation
   */
  #initializeTruncation() {
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.#calculateTruncation();
      });

      this.resizeObserver.observe(this);
      this.#calculateTruncation();
    } else {
      /** @type {Window} */
      (window).addEventListener('resize', this.#handleResize.bind(this));
      this.#calculateTruncation();
    }
  }

  /**
   * Calculate truncation for the title
   */
  #calculateTruncation() {
    /** @type {HTMLElement} */
    const textElement = this.refs.text || this.querySelector('.title-text') || this;
    if (!textElement.textContent) return;

    const containerHeight = this.clientHeight;

    const computedStyle = window.getComputedStyle(this);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const paddingTop = parseFloat(computedStyle.paddingTop);
    const paddingBottom = parseFloat(computedStyle.paddingBottom);

    const availableHeight = containerHeight - paddingTop - paddingBottom;
    const maxLines = Math.max(1, Math.floor(availableHeight / lineHeight));

    textElement.style.display = '-webkit-box';
    textElement.style.webkitBoxOrient = 'vertical';
    textElement.style.overflow = 'hidden';
    textElement.style.textOverflow = 'ellipsis';
    textElement.style.webkitLineClamp = String(maxLines);
  }

  /**
   * Handle window resize events
   */
  #handleResize() {
    this.#calculateTruncation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('resize', this.#handleResize);
  }
}

if (!customElements.get('product-title')) {
  customElements.define('product-title', ProductTitle);
}

export default ProductTitle;

document.addEventListener('DOMContentLoaded', () => {
    // Wybieramy wszystkie karty produktów (produkty w kolekcjach)
    const productCards = document.querySelectorAll('.product-card');

    if (productCards.length > 0) {
        // Stopień maksymalnego przekrzywienia (kąt)
        const maxTilt = 5; 
        // Stopień maksymalnego powiększenia (zoom)
        const maxZoom = 1.05; 
        
        productCards.forEach(card => {
            const media = card.querySelector('.product-media');

            // 1. Zdarzenie na ruch myszy (reakcja na pozycję)
            card.addEventListener('mousemove', (e) => {
                const rect = card.getBoundingClientRect();
                const width = rect.width;
                const height = rect.height;
                
                // Obliczanie współrzędnych kursora względem środka karty (od -0.5 do 0.5)
                const xAxis = (e.clientY - rect.top) / height - 0.5; // Pionowa oś
                const yAxis = (e.clientX - rect.left) / width - 0.5; // Pozioma oś

                // Obliczanie rotacji: Wartości bliższe krawędziom dają większy kąt
                // Odwrócenie osi X i Y, aby efekt był naturalny (jakbyś "pchał" obrazek)
                const rotateX = xAxis * maxTilt * -1;
                const rotateY = yAxis * maxTilt;
                
                // Zastosowanie dynamicznej transformacji i zoomu
                media.style.transform = `scale(${maxZoom}) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            });

            // 2. Zdarzenie na opuszczenie karty (powrót do stanu normalnego)
            card.addEventListener('mouseleave', () => {
                // Płynny powrót do stanu domyślnego
                media.style.transform = 'scale(1) rotateX(0deg) rotateY(0deg)';
                // Usuwamy dynamiczne cienie z JS i pozwalamy CSS przejąć kontrolę
                media.style.boxShadow = '';
            });
        });
    }
});

